import React from 'react'
import { storiesOf } from '@storybook/react'

import GameCardContent from 'components/GameCard/components/GameCardContent'

storiesOf('GameCard/GameCardContent', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#F5F5F5' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#F5F5F5', width: 320, borderTop: '1px solid #EEE' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardContent />
  ))
  .add('separated', () => (
    <GameCardContent separated />
  ))
  .add('success', () => (
    <GameCardContent variant="success" />
  ))
  .add('success & separated', () => (
    <GameCardContent variant="success" separated />
  ))
  .add('error', () => (
    <GameCardContent variant="error" />
  ))
  .add('error & separated', () => (
    <GameCardContent variant="error" separated />
  ))
  .add('quiz', () => (
    <GameCardContent variant="quiz" />
  ))
  .add('quiz & separated', () => (
    <GameCardContent variant="quiz" separated />
  ))
  .add('quiz & separated with higher content', () => (
    <GameCardContent variant="quiz" separated>
      <div style={{ height: 120 }} />
    </GameCardContent>
  ))
